// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const exportFileRouter  =
  {
    path: roterPre+`/export`,
    name: 'exportFile',
    meta: {
      icon: '',
      title: '导出文件'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'exportList',
        meta: {
          title: '导出文件'
        },
        component: () => import('@/views/exportFile/index.vue')
      }
    ]
  }

export default exportFileRouter as RouteRecordRaw